import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('stateComplianceModal');

    return {
        ACRES_PER_TANK: t('acresPerTank'),
        AERIAL_DRONE: t('aerialDrone'),
        APP_TANK: t('appTank'),
        APPLICATION_DETAILS: t('applicationDetails'),
        APPLICATION_METHOD: t('applicationMethod'),
        APPLICATION_TANK_GAL: t('applicationTankGal'),
        APPLICATOR: t('applicator'),
        APPLICATOR_NAME: t('applicatorName'),
        APPLICATOR_TYPE_LABEL: t('applicatorTypeLabel'),
        BATCHES: t('batches'),
        CA_TITLE: t('caTitle'),
        CARRIER_OTHER: t('carrierOther'),
        CARRIER_RATE: t('carrierRate'),
        CARRIER_RATE_GAL_PER_AC: t('carrierRateGalPerAc'),
        CARRIER_TYPE: t('carrierType'),
        CHEMIGATION: t('chemigation'),
        CLOSE_BUTTON: t('closeButton'),
        COMING_SOON_BODY: t('comingSoonBody'),
        COMING_SOON_TITLE: t('comingSoonTitle'),
        COMMERCIAL: t('commercial'),
        COUNTY: t('county'),
        CROP: t('crop'),
        CUSTOMER_ADDRESS: t('customerAddress'),
        CUSTOMER_NAME: t('customerName'),
        DATE: t('date'),
        DATE_PDF: t('datePdf'),
        DICAMBA_FLAG: t('dicambaFlag'),
        DOWNLOAD_PDF_BUTTON: t('downloadPdfButton'),
        EPA_COLUMN: t('epaColumn'),
        FAA_N_NUMBER: t('faaNNumber'),
        FALLBACK_TITLE: t('fallbackTitle'),
        FIELD_NAME: t('fieldName'),
        GROUND_BOOM: t('groundBoom'),
        GUST_SPEED: t('gustSpeed'),
        HUMIDITY: t('humidity'),
        LICENSE: t('license'),
        LICENSE_STATE: t('licenseState'),
        LOCATION_DESCRIPTION: t('locationDescription'),
        METHOD_LABEL: t('methodLabel'),
        MIX_TANK: t('mixTank'),
        MIX_TANK_GAL: t('mixTankGal'),
        MN_TITLE: t('mnTitle'),
        NAME_LABEL: t('nameLabel'),
        NONCOMMERCIAL: t('noncommercial'),
        NY_TITLE: t('nyTitle'),
        OIL: t('oil'),
        ORDER_COLUMN: t('orderColumn'),
        OTHER: t('other'),
        PRIVATE: t('private'),
        PRODUCT_COLUMN: t('productColumn'),
        RATE_COLUMN: t('rateColumn'),
        RECORDED_AT: t('recordedAt'),
        RESTRICTED_USE_FLAG: t('restrictedUseFlag'),
        SIGNATURE: t('signature'),
        SIGNATURE_DATE: t('signatureDate'),
        SIGNATURE_LINE: t('signatureLine'),
        SIGNED_BY: t('signedBy'),
        STATE: t('state'),
        TANK_MIX: t('tankMix'),
        TANK_VOLUME: t('tankVolume'),
        TARGET_PEST: t('targetPest'),
        TEMPERATURE: t('temperature'),
        TOTAL_ACRES: t('totalAcres'),
        TOTAL_APPLIED: t('totalApplied'),
        TOTAL_APPLIED_COLUMN: t('totalAppliedColumn'),
        TOTAL_SPRAY_VOLUME: t('totalSprayVolume'),
        TOTAL_SPRAY_VOLUME_GAL: t('totalSprayVolumeGal'),
        TYPE_LABEL: t('typeLabel'),
        UNLICENSED_REMEDIATION: t('unlicensedRemediation'),
        UNLICENSED_WARNING_BODY: t('unlicensedWarningBody'),
        UNLICENSED_WARNING_TITLE: t('unlicensedWarningTitle'),
        WATER: t('water'),
        WEATHER_AT_APPLICATION: t('weatherAtApplication'),
        WEATHER_UNAVAILABLE: t('weatherUnavailable'),
        WIND_DIRECTION: t('windDirection'),
        WIND_SPEED: t('windSpeed')
    };
};

export default useTranslation;
